import React, { Component } from 'react'
import { TreeList } from '@sencha/ext-modern'

Ext.require(['Ext.data.TreeStore'])

export default class TreeListView extends Component {
    getTreeData = (treeNodes) => {
        return treeNodes.reduce((ret, node) => {
            ret.children || (ret.children = [])
            if (node.children) 
                ret.children.push({ leaf: false, text: node.name + "：" + node.value, iconCls: null, children: this.getTreeData(node.children).children })
            else 
                ret.children.push({ leaf: true, text: node.name + "：" + node.value, iconCls: null })
            return ret
        }, {})
    }
    render() {
        const { data } = this.props
        const treeStore = Ext.create('Ext.data.TreeStore', {
            rootVisible: true,
            root: this.getTreeData(data),
        })
        return (
            <TreeList
                ref="tree"
                expanderOnly={false}
                store={treeStore}
                micro={false}
                ui={null}
                expanderFirst={true}
            />
        )
    }
}